import React from 'react';

import { Box, Stack } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { PageHeaderWithBackButton } from 'components/DataDisplay';
import { SuddenActivityIcon } from 'components/index';

import { selectIncidentResponse } from '../../../selectors';

import { ActivityGraph } from './ActivityGraph';

export const ActivityGraphPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { activityGraph: storedActivityGraph } = useSelector(
    selectIncidentResponse,
  );
  const navigationState = location.state as
    | {
        activityGraph?: typeof storedActivityGraph;
        hasSelectedResource?: boolean;
      }
    | undefined;
  const activityGraph = navigationState?.activityGraph ?? storedActivityGraph;

  return (
    <Stack h="100vh" w="full" spacing={4} p={4}>
      <Box flexShrink={0}>
        <PageHeaderWithBackButton
          label="Activity Graph"
          icon={<SuddenActivityIcon />}
          onClickBack={() => navigate(-1)}
        />
      </Box>
      <Stack flex={1} minH={0} w="full">
        <ActivityGraph
          activityGraph={activityGraph}
          hasSelectedResource={
            navigationState?.hasSelectedResource ??
            (activityGraph.isLoading || activityGraph.isSuccess)
          }
        />
      </Stack>
    </Stack>
  );
};
